import { Action, combineReducers } from '@ngrx/store';

import { 
  _CLEAR,
  CREATE_DIE,
  DELETE_DIE,
  GET_DIES,
  SET_DIE_LIST_VIEW,
  UPDATE_DIE
} from '../actions';

const initialDieListViewState = {
  initializing: <boolean>false,
  loading: <boolean>false
};

export function dieListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_DIE:
      const match = state.find(die => action.payload.die && die.id === action.payload.die.id);
      return !match
        ? [ ...state, action.payload.die ].sort(sortDies)
        : state;
    case DELETE_DIE:
      return state.filter(die => die.id !== action.payload.id);
    case GET_DIES:
      return action.payload.dies.sort(sortDies);
    case UPDATE_DIE:
      return state.map(die => {
        return die.id === action.payload.die.id
          ? action.payload.die
          : die;
      });
    default:
      return state;
  }
}

export function dieListViewReducer(state = initialDieListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case SET_DIE_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

const sortDies = (a, b) => {
  return +a.id.replace('-', '') - +b.id.replace('-', '');
};

export const dieReducers = combineReducers({
  dieList    : dieListReducer,
  dieListView: dieListViewReducer
});


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/dies.ts